import React from 'react';
import ReactDOM from 'react-dom';

import {useIsomorphicLayoutEffect} from '@packages/systems/spring-hooks';

import {useRowItemContext} from '../RowItemContext';

export const RowItemActions = ({children}: {children?: React.ReactNode}) => {
  const {rowActionsPortalRef, isRenaming} = useRowItemContext();
  const [_, forceRerender] = React.useState(false);

  const shouldRenderActions = !isRenaming && Boolean(children);

  // Portal refs are null on the first render after mount because the
  // container hasn't mounted yet. We force a rerender once the ref is
  // ready so the actions can portal into the container without flicker.
  const needsPortalRerender =
    shouldRenderActions && !rowActionsPortalRef.current;

  useIsomorphicLayoutEffect(() => {
    if (!needsPortalRerender) return;

    // We need a tick to ensure that the ref is set.
    forceRerender(true);
  }, [needsPortalRerender]);

  if (!shouldRenderActions || !rowActionsPortalRef.current) {
    return null;
  }

  return ReactDOM.createPortal(children, rowActionsPortalRef.current);
};
